import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';

export const TONE_OPTIONS = [
    { value: 'Helpful', label: 'Helpful & Polite' },
    { value: 'Snarky', label: 'Snarky & Sarcastic' },
    { value: 'Coding', label: 'Coding Expert (Concise & Technical)' }
];

export const LANGUAGE_OPTIONS = [
    { value: 'English', label: 'English' },
    { value: 'Hindi', label: 'Hindi (हिंदी)' },
    { value: 'Haryanavi', label: 'Haryanavi (हरियाणवी)' },
    { value: 'Gujarati', label: 'Gujarati (ગુજરાતી)' }
];

export default function StyleSelector({ selectedTone, onToneChange, selectedLanguage, onLanguageChange }) {
    return (
        <Box 
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                gap: 2,
                alignItems: 'center'
            }}
        >
            {/* Tone Selector */}
            <FormControl size="small" fullWidth>
                <InputLabel id="tone-select-label">AI Persona / Tone</InputLabel>
                <Select
                    labelId="tone-select-label"
                    id="toneSelect"
                    value={selectedTone}
                    label="AI Persona / Tone"
                    onChange={(e) => onToneChange(e.target.value)}
                >
                    {TONE_OPTIONS.map((tone) => (
                        <MenuItem key={tone.value} value={tone.value}>
                            {tone.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {/* Language Selector */}
            <FormControl size="small" fullWidth>
                <InputLabel id="language-select-label">Response Language</InputLabel>
                <Select
                    labelId="language-select-label"
                    id="languageSelect"
                    value={selectedLanguage}
                    label="Response Language"
                    onChange={(e) => onLanguageChange(e.target.value)}
                >
                    {LANGUAGE_OPTIONS.map((lang) => (
                        <MenuItem key={lang.value} value={lang.value}>
                            {lang.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}